import { render, staticRenderFns } from "./EditSkill.vue?vue&type=template&id=0a794389&scoped=true"
import script from "./EditSkill.vue?vue&type=script&lang=js"
export * from "./EditSkill.vue?vue&type=script&lang=js"
import style0 from "./EditSkill.vue?vue&type=style&index=0&id=0a794389&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a794389",
  null
  
)

export default component.exports